export default __webpack_public_path__ + "static/media/Retiree.f6f2f08a.png";